import { ShareLinkModal } from './ShareLinkModal';
import { GenerateLinkModal } from './GenerateLinkModal';

type PropsT = {
  availableGiftTotal: number;
  giftLink: string | null;
  goToMainView: () => void;
  isPending: boolean;
  onGenerate: () => void;
  onMobileShare: (url: string, addSourceParam?: boolean) => void;
  ariaDialogLabelId: string;
};

export const GiftView: React.FunctionComponent<PropsT> = ({
  availableGiftTotal,
  giftLink,
  goToMainView,
  isPending,
  onGenerate,
  onMobileShare,
  ariaDialogLabelId,
}) => {
  if (giftLink) {
    return (
      <ShareLinkModal
        ariaDialogLabelId={ariaDialogLabelId}
        availableGiftTotal={availableGiftTotal - 1}
        giftLink={giftLink}
        onMobileShare={onMobileShare}
      />
    );
  }

  return (
    <GenerateLinkModal
      ariaDialogLabelId={ariaDialogLabelId}
      availableGiftTotal={availableGiftTotal}
      goToMainView={goToMainView}
      isPending={isPending}
      onGenerate={onGenerate}
    />
  );
};
